import { RefObject } from 'react';

type Args = {
  lastFetchTimeRef: RefObject<Date | null>;
  maintenanceTrackerSeconds?: string;
};

const shouldFetchTechnicalPauses = ({
  lastFetchTimeRef,
  maintenanceTrackerSeconds,
}: Args) => {
  if (!lastFetchTimeRef?.current) return true;
  const now = new Date();
  const diff = now.getTime() - lastFetchTimeRef.current.getTime();
  const seconds = maintenanceTrackerSeconds
    ? parseInt(maintenanceTrackerSeconds, 10) * 1000
    : 0;
  return diff >= seconds;
};

export default shouldFetchTechnicalPauses;
